import React, { useState, useEffect } from 'react';
import { auth } from './api/client';
import { TopBar } from './components/Shared';
import Login from './components/Login';
import ResetPin from './components/ResetPin';
import TicketList from './components/TicketList';
import CreateTicket from './components/CreateTicket';
import TicketDetail from './components/TicketDetail';

export default function App() {
  const [user, setUser] = useState(auth.user);
  const [view, setView] = useState({ name: 'list' }); // list | create | detail | profile
  const [needsPin, setNeedsPin] = useState(false);

  useEffect(() => {
    if (user?.mustResetPin) setNeedsPin(true);
  }, [user]);

  // ----- not logged in -----
  if (!auth.token || !user) {
    return <Login onAuthed={(resp) => {
      setUser(auth.user);
      setNeedsPin(!!resp.mustResetPin);
      setView({ name: 'list' });
    }} />;
  }

  // ----- forced PIN reset -----
  if (needsPin) {
    return <ResetPin onDone={() => { setUser(auth.user); setNeedsPin(false); }} />;
  }

  function logout() {
    auth.clear();
    setUser(null);
    setView({ name: 'list' });
  }

  // ----- main app -----
  return (
    <div className="app-shell">
      <TopBar right={
        <button className="btn btn-ghost btn-sm" onClick={logout}>Logout</button>
      } />

      {view.name === 'list' && (
        <TicketList onOpen={(id) => setView({ name: 'detail', id })} />
      )}
      {view.name === 'create' && (
        <CreateTicket
          onCreated={(id) => setView({ name: 'detail', id })}
          onCancel={() => setView({ name: 'list' })}
        />
      )}
      {view.name === 'detail' && (
        <TicketDetail id={view.id} onBack={() => setView({ name: 'list' })} />
      )}
      {view.name === 'profile' && <Profile user={user} onLogout={logout} />}

      {/* FAB — only clients raise tickets; admins manage them */}
      {view.name === 'list' && !auth.isAdmin && (
        <button className="fab" onClick={() => setView({ name: 'create' })} aria-label="New ticket">＋</button>
      )}

      <div className="bottomnav">
        <button className={`navbtn ${view.name === 'list' ? 'active' : ''}`} onClick={() => setView({ name: 'list' })}>
          <span className="ic">🎫</span> Tickets
        </button>
        {!auth.isAdmin && (
          <button className={`navbtn ${view.name === 'create' ? 'active' : ''}`} onClick={() => setView({ name: 'create' })}>
            <span className="ic">＋</span> New
          </button>
        )}
        <button className={`navbtn ${view.name === 'profile' ? 'active' : ''}`} onClick={() => setView({ name: 'profile' })}>
          <span className="ic">👤</span> Profile
        </button>
      </div>
    </div>
  );
}

function Profile({ user, onLogout }) {
  return (
    <div className="screen">
      <h1 style={{ marginBottom: 14 }}>Profile</h1>
      <div className="card">
        <div className="kv"><span className="k">Name</span><span className="v">{user.name || '—'}</span></div>
        <div className="kv"><span className="k">Mobile</span><span className="v">{user.mobile}</span></div>
        <div className="kv"><span className="k">Company</span><span className="v">{user.companyName || '—'}</span></div>
        <div className="kv"><span className="k">Location</span><span className="v">{user.clientLocation || '—'}</span></div>
        <div className="kv"><span className="k">Role</span><span className="v">{user.role}</span></div>
      </div>
      <button className="btn btn-ghost" style={{ marginTop: 14 }} onClick={onLogout}>Logout</button>
    </div>
  );
}
